import React, { Suspense, lazy } from 'react';
import { useMainPageHooks } from '../hooks/useMainPageHooks';
import { MainPageSkeleton } from '../components/ui/loading-skeletons';
import PageHeader from '../components/ui/page-header';
import Marquee from '../components/marquee/Marquee';
import StatsView from '../components/StatsView';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../components/ui/tabs';
import { ListChecks, BarChart3 } from 'lucide-react';
import SearchBar from '../components/SearchBar';

const ScoreTableLazy = lazy(() => import('../components/ScoreTable'));

function MainPage() {
  const {
    searchQuery,
    setSearchQuery,
    sortDescending,
    toggleSort,
    showMarquee,
    toggleShowMarquee,
    darkMode,
    toggleDarkMode,
    isMosaicView,
    toggleView,
    year,
    setYear,
    gameData,
    isRealTime,
    toggleRealTime
  } = useMainPageHooks();

  return (
    <div className="min-h-screen bg-background field-texture transition-colors duration-300">
      {showMarquee && <Marquee initialData={gameData} />}
      <div className={`container mx-auto px-4 ${!showMarquee ? 'pt-4' : ''} pb-8`}>
        <PageHeader
          year={year}
          setYear={setYear}
          sortDescending={sortDescending}
          toggleSort={toggleSort}
          darkMode={darkMode}
          toggleDarkMode={toggleDarkMode}
          isMosaicView={isMosaicView}
          toggleView={toggleView}
          showMarquee={showMarquee}
          toggleShowMarquee={toggleShowMarquee}
          isRealTime={isRealTime}
          toggleRealTime={toggleRealTime}
        />

        <Tabs defaultValue="picks">
          <div className="flex items-center gap-3 mb-4">
            <TabsList>
              <TabsTrigger value="picks" className="gap-1.5">
                <ListChecks className="w-4 h-4" />
                Picks
              </TabsTrigger>
              <TabsTrigger value="stats" className="gap-1.5">
                <BarChart3 className="w-4 h-4" />
                Estadísticas
              </TabsTrigger>
            </TabsList>
            <div className="flex-1 hidden sm:block">
              <SearchBar searchQuery={searchQuery} setSearchQuery={setSearchQuery} />
            </div>
          </div>
          <div className="sm:hidden mb-4">
            <SearchBar searchQuery={searchQuery} setSearchQuery={setSearchQuery} />
          </div>

          <TabsContent value="picks">
            <Suspense fallback={<MainPageSkeleton />}>
              <ScoreTableLazy
                searchQuery={searchQuery}
                sortDescending={sortDescending}
                isMosaicView={isMosaicView}
                year={year}
                gameScoreData={gameData}
                isRealTime={isRealTime}
              />
            </Suspense>
          </TabsContent>

          <TabsContent value="stats">
            <StatsView year={year} />
          </TabsContent>
        </Tabs>
      </div>
    </div>
  );
}

export default MainPage;
